export const webAppUrl = process.env.REACT_APP_WEB_APP_URL;

//sidebarNav options
export const DASHBOARD = "Dashboard";
export const API_KEYS = "API for Text";
export const GLOSSARY = "Glossary";
export const VIDEO_TRANSLATION = "Video AI Studio";
export const WEBSITE_TRANSLATION = "Website AI Studio";
export const PROJECT = "Settings";
export const MEMBERS = "Members";
export const PROFILE = "Profile";
export const USERS = "Meetings";
export const SUBSCRIPTIONS = "Subscription Plans";
export const USAGE = "Usage";
export const SUPPORT = "Contact Us";
export const REALTIME_API= "API for Voice"
export const VIDEO_API = "API for Video"
export const MEETINGS_API = "API for Meetings";
export const PRESENTATIONS = "Presentation AI Studio";
export const CONFERENCES = "Conferences";
export const EMOTII_FOR_TEAMS = "emotii for Teams";
export const REMOVE_ACCOUNT = "remove_account";
export const DELETE_PROJECT = "delete_project";
export const REMOVE_KEY = "remove_key";
export const REMOVE_MEMBER = "remove_member";
export const CUSTOM = "Custom";
export const DELETE_PROEJCT_USERS = "delete_project_users";
export const UNSUBSCRIBE = "unsubscribe";
export const REACTIVATE_SUBSCRIPTION = "reactivate_subscription";

export const ITEMS_PER_PAGE_OPTIONS = ["10", "20", "50", "100"];

export const CURRENCY_OPTIONS = [
    { value: "GBP", label: "£\u00A0GBP" },
    { value: "USD", label: "$\u00A0USD" },
    { value: "EUR", label: "€\u00A0EUR" },
];

export const CURRENCY_SYMBOLS = { GBP: "£", USD: "$", EUR: "€" };

export const PRODUCT_LABELS = {
    meetings: "Meetings",
    api: "API",
    realtime_api: "API for Voice",
    website_translation: "Website Translation",
    presentations: "Presentations",
    video_tool: "Video Translation",
    emotii_for_teams: "emotii for Teams",
    conferences: "Conferences",
    video_translation_api: "API for Video",
    meetings_api: "API for Meetings",
};

export const PRODUCT_METRICS = {
    meetings: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
        { label: "Audio Minutes", key: "audio", limitKey: "audio_minutes", unit: "minutes" },
        { label: "Video Minutes", key: "video", limitKey: "video_minutes", unit: "minutes" },
    ],
    api: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
    ],
    realtime_api: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
        { label: "Minutes", key: "audio", limitKey: "audio_minutes", unit: "minutes" },
    ],
    website_translation: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
    ],
    presentations: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
    ],
    video_tool: [
        { label: "Video Minutes", key: "video", limitKey: "video_minutes", unit: "minutes" },
    ],
    emotii_for_teams: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
        { label: "Audio Minutes", key: "audio", limitKey: "audio_minutes", unit: "minutes" },
    ],
    conferences: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
        { label: "Audio Minutes", key: "audio", limitKey: "audio_minutes", unit: "minutes" },
        { label: "Video Minutes", key: "video", limitKey: "video_minutes", unit: "minutes" },
    ],
    video_translation_api: [
        { label: "Video Minutes", key: "video", limitKey: "video_minutes", unit: "minutes" },
    ],
    meetings_api: [
        { label: "Words", key: "words", limitKey: "tokens", unit: "words" },
        { label: "Audio Minutes", key: "audio", limitKey: "audio_minutes", unit: "minutes" },
        { label: "Video Minutes", key: "video", limitKey: "video_minutes", unit: "minutes" },
    ],
};


export const STATUS_CONFIG = {
  'completed': { variant: 'success', label: 'Translated successfully' },
  'failed': { variant: 'error', label: 'Failed' },
  'in_progress': { variant: 'warning', label: 'In progress' },
  'processing': { variant: 'warning', label: 'In progress' },
  'default': { variant: 'default', label: 'Unknown' }
};

export const getStatusConfig = (status) => {
  if (!status || status === "-") return null;
  return STATUS_CONFIG[status.toLowerCase()] || STATUS_CONFIG['default'];
};

export const VIDEO_STATUS_CONFIG = {
  'pending': { variant: 'warning', label: 'Pending' },
  'uploading': { variant: 'warning', label: 'Uploading' },
  'submitted': { variant: 'warning', label: 'Submitted' },
  'processing': { variant: 'warning', label: 'Processing' },
  'completed': { variant: 'success', label: 'Completed' },
  'failed': { variant: 'error', label: 'Failed' },
  'rejected': { variant: 'error', label: 'Rejected' },
  'default': { variant: 'default', label: 'Unknown' }
};

export const getVideoStatusConfig = (status) => {
  if (!status || status === "-") return null;
  return VIDEO_STATUS_CONFIG[status.toLowerCase()] || VIDEO_STATUS_CONFIG['default'];
};